export const lvzInfoWindowSelector = ({lvzInfoWindow}) => lvzInfoWindow